
    import './styles.scoped.css';
    export default {
  "breadcrumb-group": "awsui_breadcrumb-group_d19fg_1s1b9_9",
  "breadcrumb-group-list": "awsui_breadcrumb-group-list_d19fg_1s1b9_44",
  "ghost": "awsui_ghost_d19fg_1s1b9_55",
  "item": "awsui_item_d19fg_1s1b9_60",
  "ghost-item": "awsui_ghost-item_d19fg_1s1b9_61",
  "ellipsis": "awsui_ellipsis_d19fg_1s1b9_62",
  "hide": "awsui_hide_d19fg_1s1b9_73",
  "visible": "awsui_visible_d19fg_1s1b9_79",
  "icon": "awsui_icon_d19fg_1s1b9_83",
  "breadcrumbs-skeleton": "awsui_breadcrumbs-skeleton_d19fg_1s1b9_92",
  "collapsed-button": "awsui_collapsed-button_d19fg_1s1b9_96",
  "button-icon": "awsui_button-icon_d19fg_1s1b9_178",
  "button-icon-open": "awsui_button-icon-open_d19fg_1s1b9_192",
  "hidden": "awsui_hidden_d19fg_1s1b9_196"
};
  